export default "__VITE_ASSET__BwqLm4Ys__"